var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.27637V6.94426H5.36364",
    stroke: "#1F242E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0004 14.7236V10.0557H12.6367",
    stroke: "#1F242E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1745 6.16605C14.8057 5.05104 14.1788 4.05414 13.3524 3.26839C12.526 2.48264 11.5269 1.93365 10.4485 1.67263C9.3701 1.41161 8.24745 1.44708 7.18532 1.77572C6.12318 2.10437 5.15618 2.71548 4.37455 3.55203L1 6.94404M17 10.056L13.6255 13.448C12.8438 14.2845 11.8768 14.8956 10.8147 15.2243C9.75255 15.5529 8.6299 15.5884 7.55148 15.3274C6.47307 15.0664 5.47404 14.5174 4.64761 13.7316C3.82119 12.9459 3.1943 11.949 2.82545 10.8339",
    stroke: "#1F242E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/Reset_icon.9c77ad17407266c1e6efbb6d3546a71c.svg";
export { ForwardRef as ReactComponent };